
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {
  getSearchInventory,
  putSaveChooseInventory
} from "@/api/proforma";
import Template from "@/views/system-management/template/index.vue";
import {Message} from "element-ui";
import Space from "@/views/warehouse-management/space/index.vue";
import {queryUsedPacking} from "@/api/customs-packing";

@Component({
  name: "normalUsedInventory",
  components: {Space, Template},
})
export default class extends Vue {
  @Prop({default: false}) private show: boolean;
  @Prop({default: "选择库存"}) private title: "";
  @Prop({default: []}) private inventories: [] | any;
  @Prop({default: 0}) private remaining: number;
  @Prop({default: ''}) private curPiInfoId: string;

  private inventoryList: Inventory[] = [];

  @Watch("show", {immediate: true})
  private watchShow() {
    if (this.show) {
      this.inventoryList = this.inventories;
      this.inventoryList.forEach(item => {
        if (!item.packingCodes) {
          item.packingCodes = "选择库存"
        }
      })
      this.curRemainingQty = this.remaining;
    }
  }

  private close() {
    this.usedInventories = [];
    this.$emit("update:show", false);
  }

  private packingDialog = false;

  private curRemainingQty = 0;

  /**
   * 选择库存dialog关闭事件
   * @private
   */
  private closePacking() {
    if (this.curInventory.used) {
      this.packingDialog = false;
      return;
    }
    // 清空库存选择数量；
    this.selectedTotalQty = 0;
    this.lastTimeSelectedQty = 0;
    this.selectedInventoryPackings = [];
    // 关闭dialog
    this.packingDialog = false;
  }

  private inventoryPackings: InventoryPacking[] = [];
  private lookLoading = false;
  /**
   * 当前库存记录
   * @private
   */
  private curInventory: Inventory;

  /**
   * 查看库存包装
   * @private
   */
  private async lookPacking(row: Inventory) {
    this.lookLoading = true;
    this.curInventory = row;
    try {
      if (row.used) {
        let data: any = await queryUsedPacking(this.curPiInfoId, row.poInfoId);
        this.inventoryPackings = data;
        this.inventoryPackings.forEach(item => {
          item.selectedQty = item.inventoryQtyByPoInfo
          item.disable = !item.available
        });
      } else {
        let data: any = await getSearchInventory(row.poInfoId);
        this.inventoryPackings = data;
        this.$nextTick(() => {
          this.inventoryPackings.forEach(item => {
            item.disable = !item.available;
          });
        })
        await this.$nextTick();
        await this.recovery();
      }
      this.packingDialog = true;
    } catch (error) {
      console.log(error);
    } finally {
      this.lookLoading = false;
    }
  }

  private async  recovery() {
    if (this.usedInventories.length === 0) {
      return;
    }
    let inventory = this.usedInventories.find(item => item.inventoryId === this.curInventory.id);
    if (inventory === undefined) {
      return;
    }
    let packings = inventory.packings;
    let selectedPackings = [];
    this.$nextTick(() => {
      this.inventoryPackings.forEach(p => {
        p.disable = !p.available;
        let exist = packings.some(i => i.id === p.id);
        if (exist) {
          let usedPacking = packings.filter(i => i.id === p.id)[0];
          p.selectedQty = usedPacking.selectedQty;
          p.disable = usedPacking.selectedQty === usedPacking.inventoryQty;
          let multipleTable: any = this.$refs.multipleTable;
          multipleTable.toggleRowSelection(p, true);
          selectedPackings.push(p);
        }
      });
      this.selectedInventoryPackings = selectedPackings;
      this.updateSelectedQty();
      this.lastTimeSelectedQty = this.selectedTotalQty;
    });
    await this.$nextTick().then(() => {
      this.inventoryPackings.forEach( p => {
        if (p.inventoryState === '尾差') {
          p.disable = true;
        }
      })
    });

  }

  /**
   * 是否可以被选择。只有库存类型才可以被选择
   * @param row
   * @param index
   * @private
   */
  private checkSelectable(row: InventoryPacking, index) {
    return row.available;
  }

  /**
   * 选择的包装
   * @private
   */
  private selectedInventoryPackings: InventoryPacking[] = [];
  /**
   * 选择的库存数量
   * @private
   */
  private selectedTotalQty = 0;

  /**
   * 库存下的主包装的单选勾选操作。
   * 超出数量，就不做勾选。
   * @private
   */
  private handleSelect(selection,row) {
    this.updateInventoryPacking(row);
    if (this.checkQtyIsMoreThan(selection)) {
      this.selectedInventoryPackings = selection;
      this.updateSelectedQty();
      return;
    }
    this.clearSelectQty(row);
    let multipleTable:any = this.$refs.multipleTable;
    this.$nextTick((() => {
      multipleTable.toggleRowSelection(row, false);
    }))
    return false;
  }

  /**
   * 库存下的主包装的全选勾选操作。
   * 超出数量，就不做勾选。
   * @param selection
   * @private
   */
  private handleSelectAll(selection) {
    selection.forEach(item => this.updateInventoryPacking(item))
    if (this.checkQtyIsMoreThan(selection)) {
      this.selectedInventoryPackings = selection;
      this.updateSelectedQty();
      return;
    }
    selection.forEach(item => this.clearSelectQty(item))
    let multipleTable:any = this.$refs.multipleTable;
    this.$nextTick((() => {
      multipleTable.clearSelection();
    }))
    return false;
  }

  /**
   * 取消勾选的做处理。
   * @private
   */
  private handleSelectionChange(selectedItems: InventoryPacking[]) {
    const resetRow = (row: InventoryPacking) => {
      row.selectedQty = null;
      row.disable = false;
    };
    const rowsToReset = selectedItems.length === 0
        ? this.inventoryPackings
        : this.inventoryPackings.filter(row => !selectedItems.some(item => item.id === row.id));
    rowsToReset.forEach(row => resetRow(row));
  }

  private updateSelectedQty() {
    this.selectedTotalQty = this.selectedInventoryPackings
        .map(item => item.selectedQty)
        .reduce((a, b) => a + b, 0)
  }

  /**
   * 将勾选中的包装默认数量全部选择。尾差的不作处理
   * 更新选择数量以及可更新项
   * @param row
   * @private
   */
  private updateInventoryPacking(row: InventoryPacking) {
    if (row.selectedQty && row.selectedQty < row.inventoryQtyByPoInfo) {
      return;
    }
    row.selectedQty = row.inventoryQtyByPoInfo;
    row.disable = true;
  }

  /**
   * 清空选择数量以及可更新项，为校验失败做清空处理
   * @param row
   * @private
   */
  private clearSelectQty(row: InventoryPacking) {
    if (row.selectedQty && row.selectedQty < row.inventoryQtyByPoInfo) {
      return;
    }
    row.selectedQty = null;
    row.disable = false;
  }

  /**
   * 单个选择。
   * tableKey: 用于强制刷新表格。因为input事件在输入多位数时刷新会有问题。
   * 思路：
   * 数量存在 -> 校验数量是否合理
   *                      -> 不合理： 清空数量，并报错
   *                      -> 合理： 将数量放入当前行的选择数量中，判断数量是否超出该行的可选数量
   *                          -> 超出：将可选数量作为数量放入选择数量中
   *        -> 校验选择数量是否超出剩余可选择数量
   *          -> 超出：报错
   *          -> 未超出：将当前行增加至选择行。
   * 数量不存在 -> 清空该行的勾选
   * @private
   */
  private selectQty(val, row: InventoryPacking) {
    if (val) {
      // 只允许输入正整数
      const regex = /^[1-9]\d*$/;
      if (!regex.test(row.selectedQty +'')) {
        this.$message.error('请输入正整数');
        row.selectedQty = null;
        return;
      }
      row.selectedQty = Number(val);
      if (row.selectedQty >= row.inventoryQtyByPoInfo) {
        row.selectedQty = row.inventoryQtyByPoInfo;
        row.disable = true;
      }
      // 判断选择的数量是否超出所需库存数，超出则不增加其选择框
      let newArr:InventoryPacking[] = this.getNewTempSelection(row);
      if (this.checkQtyIsMoreThan(newArr)) {
        this.$nextTick(() => {
          let multipleTable = this.$refs.multipleTable as any;
          multipleTable.toggleRowSelection(row, true);
          this.selectedInventoryPackings = newArr;
          this.updateSelectedQty();
        })
      } else {
        row.selectedQty = null;
        row.disable = false;
        // 防止第一次输入在范围内，然后再次输入超出范围，然后勾选框仍选中
        let multipleTable = this.$refs.multipleTable as any;
        multipleTable.toggleRowSelection(row,false);
      }
    }
  }

  /**
   * 校验选择的数量是否有超过异常处理的数量.
   *
   * 如果增加的勾选行，选择的库存数量，超出，所需库存总数。则移除勾选行
   * @private
   * @param rows 增加的勾选行。
   * @return boolean  rue:没有问题可以正常进行，false：超出所需库存数量
   */
  private checkQtyIsMoreThan(rows: InventoryPacking[]) :boolean{
    if (rows.length === 0) {
      return true;
    }
    let totalSelectedQty: number = rows
        .map((item) => item.selectedQty ? item.selectedQty : 0)
        .reduce((a, b) => a + b, 0);
    if (totalSelectedQty > this.curRemainingQty) {
      this.$message.error("选择的主包装的库存产品总数量【" + totalSelectedQty + "】，超出剩余处置数量【" + this.curRemainingQty + "】")
      return false;
    }
    return true;
  }

  /**
   *  获取新的选中行，主要是为了校验填入数量是否超出。
   *  这里if条件判断主要是为了对于多次输入同一行的内容做的处理。
   * @param row
   * @private
   */
  private getNewTempSelection(row: InventoryPacking):InventoryPacking[] {
    if (this.selectedInventoryPackings.some(item => item.id === row.id)){
      let selected:InventoryPacking[] = this.selectedInventoryPackings.filter(item => item.id !== row.id);
      return [row, ...selected];
    } else {
      return [row, ...this.selectedInventoryPackings];
    }
  }

  /**
   * 选择库存，点击确定
   * @private
   */
  private usedInventories: UsedInventory[] = [];

  private lastTimeSelectedQty = 0;

  private handleSubmitBySelectPacking() {
    if (this.curInventory.used) {
      this.packingDialog = false;
      return;
    }
    // 更新剩余选择数量
    let selectedQty = this.selectedInventoryPackings
        .map((item) => item.selectedQty)
        .reduce((a, b) => a + b, 0);
    // 其中一个库存绑定包装后，剩余可处置数量减去已选择数量
    let newCurQty =  this.curRemainingQty + this.lastTimeSelectedQty - selectedQty;
    if (newCurQty < 0) {
      this.$message.error("剩余可处置数量不足");
      return;
    }
    this.curRemainingQty = newCurQty;
    this.$set(this.curInventory, 'usedQty', this.selectedTotalQty);
    let existPackings = this.selectedInventoryPackings.length > 0;
    this.$set(this.curInventory, 'packingCodes',
        existPackings
            ? this.selectedInventoryPackings.map(item => item.code).join("|")
            : "选择库存");
    this.updateUsedInventory(this.curInventory.id, this.selectedInventoryPackings, existPackings);
    this.closePacking();
  }

  /**
   * 更新某个库存所选择的包装。
   * 存在选择的包装时，且原来记录过选择。则更新。
   * 不存在选择的包装时，取非该库存记录的内容。
   * @param inventoryId 库存id
   * @param packings 主包装
   * @private
   */
  private updateUsedInventory(inventoryId: string, packings: InventoryPacking[], existPackings: boolean) {
    let otherInventories = this.usedInventories.filter(item => item.inventoryId !== inventoryId);
    if (existPackings) {
      let usedPackings = packings.map(item => {
        return new UsedPacking(item.id, item.inventoryState, item.inventoryQtyByPoInfo, item.selectedQty);
      });
      let usedInventory = new UsedInventory(inventoryId, usedPackings);
      otherInventories.push(usedInventory);
    }
    this.usedInventories = otherInventories;
  }

  private submitLoading = false;

  private async handleSubmit() {
    this.submitLoading = true;
    try {
      await putSaveChooseInventory(this.curPiInfoId, this.usedInventories);
      this.close();
      this.$emit("success");
    } catch (error) {
      console.error(error);
    } finally {
      this.submitLoading = false;
    }
  }
}

class Inventory {
  id: string;
  poInfoId: string;
  purchaseOrderCode: string;
  supplierName: string;
  inventoryQuantity: number;
  orderTime: Date;
  hqPackingListCode: string;
  warehousingProgress: string;
  productUnit: string;
  remark: string;
  purchaseDiscountPrice: number;
  // 如使用过库存的，则后端返回该值，否则是null
  usedQty: number;
  // 如使用过库存的，则后端返回该值，否则是null。
  packingCodes: string;
  /**
   * 该库存记录，是否被PI正常使用过。
   */
  used: boolean;
}

class InventoryPacking {
  id: string;
  code: string;
  totalQty: number;
  inventoryQtyByPoInfo: number;
  inventoryState: string;
  available: boolean;
  /**
   * 用于判断是否可以填写选择库存数量。初始化用!abailable 赋值。后续如果数量全部选择的设定为true。
   */
  disable: boolean;
  selectedQty: number;
}

class UsedInventory {
  inventoryId: string;
  packings: UsedPacking[];

  constructor(inventoryId: string, packings: UsedPacking[]) {
    this.inventoryId = inventoryId;
    this.packings = packings;
  }
}

class UsedPacking {
  id: string;
  inventoryState: string;
  inventoryQty: number;
  selectedQty: number;

  constructor(id: string, inventoryState: string, inventoryQty: number, selectedQty: number) {
    this.id = id;
    this.inventoryState = inventoryState;
    this.inventoryQty = inventoryQty;
    this.selectedQty = selectedQty;
  }
}
